import { useTheme } from '@mui/material'

/**
 *
 * @param {object} props
 * @param {string[]} props.labels - Array of strings to be displayed
 * @param {string} props.itemId - Id of the item to be displayed
 * @param {JSX.Element} props.icon - Icon to be displayed
 * @param {function(string)} props.onIconClick - Function to be called when the icon is clicked
 * @param {'default' | 'group' } props.variant - Visual variant
 * @returns
 */
const GenericSortableRenderItem = ({ labels, itemId, icon, onIconClick, variant = 'default' }) => {
  const theme = useTheme()
  const margin = 0.6

  const variantStyles = {
    group: {
      border: `2px solid ${theme.palette.primary.main}`,
      background: `${theme.palette.primary.main}22`,
      borderRadius: '10px'
    },
    default: {
      border: '1px solid #b8b7b7',
      background: theme.palette.background.default,
      borderRadius: '10px'
    }
  }

  const style = {
    display: 'flex',
    width: '100%',
    ...variantStyles[variant],
    marginBottom: margin + 'rem',
    justifyContent: 'space-between',
    padding: margin + 'rem',
    paddingLeft: '3rem',
    paddingRight: '1rem',
    columnGap: '3rem'
  }
  const style2 = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }
  const styleIcon = {
    cursor: 'pointer',
    position: 'relative'
  }

  return (
    <div style={style}>
      <div style={style2}>
        {labels.map((label, index) => (
          <span
            key={'Generic-Sortable-Item-' + index + '-' + label}
          >
            {label}
          </span>
        ))}
      </div>
      {
        icon &&
          <div
            onClick={(event) => { onIconClick(itemId) }}
            style={styleIcon}
          >
            {icon}
          </div>
      }
    </div>
  )
}

export default GenericSortableRenderItem
